var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "#1513C3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6255 1.3335H5.99561C5.2962 1.3335 4.72396 1.9335 4.72396 2.66683V10.6668C4.72396 11.4002 5.2962 12.0002 5.99561 12.0002H13.6255C14.3249 12.0002 14.8972 11.4002 14.8972 10.6668V2.66683C14.8972 1.9335 14.3249 1.3335 13.6255 1.3335ZM8.221 6.3335C8.221 6.88683 7.79499 7.3335 7.26726 7.3335H6.63144V8.66683H5.6777V4.66683H7.26726C7.79499 4.66683 8.221 5.1135 8.221 5.66683V6.3335ZM11.4001 7.66683C11.4001 8.22016 10.9741 8.66683 10.4464 8.66683H8.85682V4.66683H10.4464C10.9741 4.66683 11.4001 5.1135 11.4001 5.66683V7.66683ZM13.9434 5.66683H12.9897V6.3335H13.9434V7.3335H12.9897V8.66683H12.0359V4.66683H13.9434V5.66683ZM6.63144 6.3335H7.26726V5.66683H6.63144V6.3335ZM3.45231 4.00016H2.18066V13.3335C2.18066 14.0668 2.75291 14.6668 3.45231 14.6668H12.3539V13.3335H3.45231V4.00016ZM9.81056 7.66683H10.4464V5.66683H9.81056V7.66683Z",
    fill: "#1513C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillPdf);
export default __webpack_public_path__ + "static/media/BillPdf.3ed4d38dfd0acf662a174a45a2038eab.svg";
export { ForwardRef as ReactComponent };